'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('prop-types');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
require('./settings-9ee2f03f.js');
require('./style-222d2b0f.js');
require('./typography/span.js');
require('./typography/b16.js');
var box = require('./terms/box.js');
require('./typography/t24.js');
require('./buttons-color-d198c1b7.js');
require('./button/button-icon.js');
var mobileInfoOverlay = require('./mobile-info-overlay.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  @media (max-width: 767px) {\n    ", ";\n  }\n"], ["\n  ", ";\n  @media (max-width: 767px) {\n    ", ";\n  }\n"]);

var Container = styled__default.div(_templateObject, function (props) {
  return props.height && "height: " + props.height;
}, function (props) {
  return props.mHeight && "height: " + props.mHeight;
});

var InfoBox = function (_React$Component) {
  _babelHelpers.inherits(InfoBox, _React$Component);

  function InfoBox(props) {
    _babelHelpers.classCallCheck(this, InfoBox);

    var _this = _babelHelpers.possibleConstructorReturn(this, (InfoBox.__proto__ || Object.getPrototypeOf(InfoBox)).call(this, props));

    _this.state = {
      showMobileOverlay: false
    };
    _this.openMobileOverlay = _this.openMobileOverlay.bind(_this);
    _this.closeMobileOverlay = _this.closeMobileOverlay.bind(_this);
    return _this;
  }

  _babelHelpers.createClass(InfoBox, [{
    key: "openMobileOverlay",
    value: function openMobileOverlay() {
      this.setState({ showMobileOverlay: true });
    }
  }, {
    key: "closeMobileOverlay",
    value: function closeMobileOverlay() {
      this.setState({ showMobileOverlay: false });
    }
  }, {
    key: "render",
    value: function render() {
      var showMobileOverlay = this.state.showMobileOverlay;
      var _props = this.props,
          children = _props.children,
          height = _props.height,
          mHeight = _props.mHeight,
          _props$titleMobile = _props.titleMobile,
          titleMobile = _props$titleMobile === undefined ? "Service Agreement" : _props$titleMobile,
          rest = _babelHelpers.objectWithoutProperties(_props, ["children", "height", "mHeight", "titleMobile"]);

      return React__default.createElement(
        Container,
        { height: height, mHeight: mHeight },
        React__default.createElement(
          mobileInfoOverlay.default,
          {
            showOverlay: showMobileOverlay,
            title: titleMobile,
            onClickCloseButton: this.closeMobileOverlay },
          children
        ),
        React__default.createElement(
          box.default,
          _babelHelpers._extends({
            onClickOverlay: this.openMobileOverlay,
            heightWithUnit: true,
            height: "100%",
            mHeight: "100%"
          }, rest),
          children
        )
      );
    }
  }]);
  return InfoBox;
}(React__default.Component);
InfoBox.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "openMobileOverlay",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closeMobileOverlay",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "InfoBox"
};

module.exports = InfoBox;
//# sourceMappingURL=info-box.js.map
